import { Component, ContentChild, EventEmitter, Input, output, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-inplace',
  templateUrl: './inplace.component.html',
  styleUrl: './inplace.component.scss',
  standalone: false
})
export class InplaceComponent {
  @Input() disabled: boolean;

  @ContentChild('viewMode') viewMode: TemplateRef<Element>;
  @ContentChild('editMode') editMode: TemplateRef<Element>;

  @Output() resetValue = new EventEmitter();
  @Output() setValue = new EventEmitter();

  editModeActive = output<boolean>();
}
